import { Injectable, NgZone } from '@angular/core';

import { MessageEventMessage } from '../models';
import { ScopedWebSocketBaseService } from './scoped-websocket-base.service';
import { MessageCommunicationService } from '../../services/message-communication.service';

@Injectable({
  providedIn: 'root'
})
export class MessageWebsocketService extends ScopedWebSocketBaseService {
  constructor(
    zone: NgZone,
    private readonly messageCommunicationService: MessageCommunicationService
  ) {
    super('Message WS', zone);
  }

  protected buildUrl(userId: string, token: string): string {
    return this.buildDomainSocketUrl('MessageManagement', userId, token);
  }

  protected handleParsedMessage(data: MessageEventMessage): void {
    if (!data || typeof data !== 'object') {
      console.warn('Ignoring invalid message payload', data);
      return;
    }

    if ((data as any).type === 'heartbeat') {
      console.debug('Ignoring heartbeat on Message WS', data);
      return;
    }

    if (data.event_type && data.event_type !== 'message_event') {
      console.warn('Ignoring invalid message payload', data);
      return;
    }

    const messageId = data.message_id ?? data.messageId;
    if (!messageId) {
      console.warn('Ignoring invalid message payload', data);
      return;
    }

    this.messageCommunicationService.emitMessageEvent(data);
  }
}
